// Module
var code = "<select class=\"form-control\" ng-model=\"$ctrl.swModel\" ng-disabled=\"$ctrl.swReadonly\" ng-change=\"$ctrl.change($ctrl.swModel)\"> <option ng-value=\"currency.code\" ng-repeat=\"currency in $ctrl.currenciesList\"> {{ currency.code }} - {{ currency.currency }} </option> </select> ";
// Exports
export default code;